import { render, staticRenderFns } from "./RecipeAudit.vue?vue&type=template&id=1945fa4c&scoped=true"
import script from "./RecipeAudit.vue?vue&type=script&lang=js"
export * from "./RecipeAudit.vue?vue&type=script&lang=js"
import style0 from "./RecipeAudit.vue?vue&type=style&index=0&id=1945fa4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945fa4c",
  null
  
)

export default component.exports